import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes}  from 'react-router-dom';

import Login from './components/login';
import Event from './components/event';
import HomeBtn from './components/HomeBtn';
import S_lea_event from './sunpharma(1)/lea_event';
import S_case_event from './sunpharma(1)/case_event';
import S_lea_video from './sunpharma(1)/lea_video';
import S_lea_virtual from './sunpharma(1)/lea_virtual';
import S_case_article from './sunpharma(1)/case_article';
import S_case_study from './sunpharma(1)/case_study';
import S_case_journal from './sunpharma(1)/case_journal';

// medeuon -->
import D_lea_video from './medeuon(2)/lea_video';
import D_lea_virtual from './medeuon(2)/lea_virtual';
import D_case_article from './medeuon(2)/case_article';
import D_case_study from './medeuon(2)/case_study';
import D_case_journal from './medeuon(2)/case_journal';

// sunpharma
import Mcq from './sunpharma(1)/mcq';
import Mcq_ans from './sunpharma(1)/mcq_ans';

//comp
import Error from './components/404_error';
import Certificate from './components/certificate';

function App() {
  return (

    // <Router basename="/dixit.medeuon/lms/">

    <Router basename="./">
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route path="/event" element={<Event/>} />
        <Route path="/HomeBtn" element={HomeBtn}/>
        <Route path="/lea_event" element={<S_lea_event/>} />
        <Route path="/case_event" element={<S_case_event/>} />
        <Route path="/lea_video" element={<S_lea_video/>} />
        <Route path="/lea_virtual" element={<S_lea_virtual/>} />
        <Route path="/case_article" element={<S_case_article/>} />
        <Route path="/case_study" element={<S_case_study/>} />
        <Route path="/case_journal" element={<S_case_journal/>} />

        <Route path="*" element={<Error/>} />
        <Route path="/certificate" element={<Certificate/>} />

        {/* dr_reddy ---> */}
        <Route path="/medeuon(2)/lea_video" element={<D_lea_video/>} />
        <Route path="/medeuon(2)/lea_virtual" element={<D_lea_virtual/>} />
        <Route path="/medeuon(2)/case_article" element={<D_case_article/>} />
        <Route path="/medeuon(2)/case_study" element={<D_case_study/>} />
        <Route path="/medeuon(2)/case_journal" element={<D_case_journal/>} />

        <Route path="/mcq" element={<Mcq/>} />
        <Route path="/mcq_ans" element={<Mcq_ans/>} />
      </Routes>
    </Router>
   
  );
}

export default App;
